import { VueAutosuggest } from 'vue-autosuggest'
import Vue from 'vue'

Vue.component('vue-autosuggest', VueAutosuggest)
